module.exports = __webpack_public_path__ + "img/gw.fffa2995.svg";